import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RegistrationModal from '../../RegistrationModal';
import { analyticsTrack } from '../../../analyticsUtils';
import './GetStartedCTA.scss';
function GetStartedCTA(_ref) {
  var csrfToken = _ref.csrfToken,
    googleOmniauthUrl = _ref.googleOmniauthUrl,
    msOmniauthUrl = _ref.msOmniauthUrl,
    signInUrl = _ref.signInUrl,
    location = _ref.location,
    projectResourceId = _ref.projectResourceId,
    inviterId = _ref.inviterId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRegistrationModal = _useState2[0],
    setShowRegistrationModal = _useState2[1];

  // Read invitee email from URL query params to prefill registration email
  var invitedEmailFromUrl = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('email') : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "get-started-cta"
  }, "Ready to find your consultant?", /*#__PURE__*/React.createElement("div", {
    className: "cta-row"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      setShowRegistrationModal(true);
      analyticsTrack('Clicked on get started', {
        location: location
      });
    }
  }, "Get Started"), /*#__PURE__*/React.createElement("div", null, "Already have a Clora account?", /*#__PURE__*/React.createElement("a", {
    href: signInUrl,
    className: "login-link text-decoration-none m-0 px-2 fs-6 fw-semibold"
  }, "Log In Here."))), /*#__PURE__*/React.createElement(RegistrationModal, {
    csrfToken: csrfToken,
    showModal: showRegistrationModal,
    hideModal: function hideModal() {
      return setShowRegistrationModal(false);
    },
    googleOmniauthUrl: googleOmniauthUrl,
    msOmniauthUrl: msOmniauthUrl,
    signInUrl: signInUrl,
    showTestimonials: false,
    location: location,
    inviterId: inviterId,
    projectResourceId: projectResourceId,
    invitedEmail: invitedEmailFromUrl
  }));
}
GetStartedCTA.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string
};
GetStartedCTA.defaultProps = {
  location: 'Projects page',
  inviterId: null,
  projectResourceId: null
};
export default GetStartedCTA;